<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="520"
    transition="dialog-bottom-transition"
  >
    <v-card class="luto-card">

      <!-- Imagen -->
      <v-img
        src="https://trackandraces.com/dominio/tr/luto.jpg"
        contain
        class="luto-image"
      />

      <!-- Botón -->
      <v-btn
        rounded
        dark
        class="bottom-close-btn"
        @click="closeDialog"
      >
        <v-icon left small>mdi-check</v-icon>
        Cerrar
      </v-btn>

    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "SolidarityModal",

  data() {
    return {
      dialog: false,
    };
  },

  mounted() {
    if (!sessionStorage.getItem("luto_modal_shown")) {
      setTimeout(() => {
        this.dialog = true;
      }, 1000);
    }
  },

  methods: {
    closeDialog() {
      sessionStorage.setItem("luto_modal_shown", "true");
      this.dialog = false;
    },
  },
};
</script>

<style scoped>
.luto-card {
  position: relative;
  overflow: hidden;
  border-radius: 14px;
  background: #000;
  box-shadow: 0 18px 50px rgba(0, 0, 0, .55);
}

.luto-image {
  display: block;
  background: #000;
}

/* Botón flotante */
.bottom-close-btn {
  position: absolute;
  left: 18px;
  bottom: 18px;
  z-index: 20;

  text-transform: none !important;
  font-weight: 600;
  font-size: 14px;
  letter-spacing: .3px;

  height: 42px !important;
  padding: 0 18px !important;

  color: #fff !important;

  background: rgba(0, 0, 0, .45) !important;
  backdrop-filter: blur(12px);
  border: 1px solid rgba(255,255,255,.25);

  transition: all .25s ease;
}

.bottom-close-btn:hover {
  background: rgba(255,255,255,.12) !important;
  transform: translateY(-2px);
}

.bottom-close-btn .v-icon {
  margin-right: 4px;
}

@media (max-width: 600px) {
  .luto-card {
    border-radius: 10px;
  }

  .bottom-close-btn {
    left: 12px;
    bottom: 12px;
    height: 38px !important;
    padding: 0 14px !important;
    font-size: 13px;
  }
}
</style>